import { mapActions, mapState } from 'vuex';
import pageUrls from '@/router/pageUrls';

const { companiesPage } = pageUrls;

export default {
  data() {
    return {
      companyId: null,
    };
  },
  computed: {
    ...mapState({
      currentCompany: (state) => state.companies.currentCompany,
      isCurrentCompanyLoaded: (state) => state.companies.isCurrentCompanyLoaded,
    }),
  },
  methods: {
    ...mapActions({
      getCompanyAction: 'companies/getCompany',
    }),
    async loadCompany() {
      if (this.companyId) {
        await this.getCompanyAction(this.companyId);
      }
    },
    navigateBack() {
      this.$router.push(companiesPage);
    },
  },
  created() {
    this.companyId = this.$route.params.id;
  },
  async mounted() {
    await this.loadCompany();
  },
};
